import { LinkedinRegExp, NameRegExp, PhoneRegExp } from './regularExpression';

export const VALID: unknown = undefined;

export const validateRegex =
  (errorMessage: string, regexp: RegExp) => (value: string) =>
    regexp.test(value) ? undefined : errorMessage;

export const validateRequired = (errorMessage: string) => (value: string) => {
  if (value) return VALID;

  return errorMessage ?? '';
};

export const validatePasswordRepeat =
  (errorMessage: string) => (value: string, allValues: any) => {
    return value !== allValues.password ? errorMessage : undefined;
  };

export const validatePhone =
  (errorMessage = 'Please enter a valid phone number.') =>
  (value?: string) => {
    if (!value) return VALID;

    const sanitized = value.replace(/[\s()-]/g, '');

    return PhoneRegExp.test(sanitized) ? VALID : errorMessage;
  };

export const validateUrl =
  (errorMessage = 'Please enter a valid URL.') =>
  (value?: string) => {
    if (!value) return VALID;

    try {
      new URL(value);
      return VALID;
    } catch {
      return errorMessage;
    }
  };

export const validateLinkedIn =
  (errorMessage = 'Please enter a valid LinkedIn URL.') =>
  (value?: string) => {
    if (!value) return VALID;

    return LinkedinRegExp.test(value) ? VALID : errorMessage;
  };

export const validateName =
  (errorMessage = 'Please enter a valid name.') =>
  (value?: string) => {
    if (!value) return VALID;

    return NameRegExp.test(value.trim()) ? VALID : errorMessage;
  };

export const composeValidators =
  (...validators: Array<any>) =>
  (value: any, allValues: Record<string, any>) => {
    return validators.reduce((errorMessage, validator) => {
      return errorMessage || validator(value, allValues);
    }, undefined);
  };
